import React from 'react';
import classNames from 'classnames';
import { uiLocations } from 'constants/analytics';
import EditTrigger from 'triggers/EditTrigger';

interface NameProps {
  canManualScript: boolean;
  isSelected: boolean;
  name: string;
  onClickEditTrigger: () => void;
  scriptId: string;
  testId?: string;
}

const Name = ({
  canManualScript,
  isSelected,
  name,
  onClickEditTrigger,
  scriptId,
  testId
}: NameProps) => {
  const classString = classNames({
    'vra-name': true
  });

  const content = isSelected && canManualScript
    ? (
      <EditTrigger
        onClickEditTrigger={onClickEditTrigger}
        scriptId={scriptId}
        text={name}
        uiLocation={uiLocations.MANAGE_SCRIPT_NAME}
      />
    )
    : (
      <div className={classString}>
        {name}
      </div>
    );

  return (
    <section className={classString} data-test-id={testId}>
      {content}
    </section>
  );
};

export default Name;
